/* eslint-disable react/prop-types */
import classes from './OurClients.module.scss'
// import {customers} from '../Data/customers' ;
import {customersFeedback as customers} from '../../Data/customers' ;
// import { IoCloudDoneSharp } from "react-icons/io5";
import { FaQuoteLeft } from "react-icons/fa";

//----------------------------------------
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const Card = ({title , overview , secImg , name}) =>{
    return (
        <div className={classes.cardCon}>
            <div className={classes.cardHead}>
                <h4>{name}</h4>
                <h6>{title}</h6>
                <img src={secImg} alt="avatar" loading="lazy"/>
            </div>
            <div className={classes.cardBody} >
                <p>"{overview}"</p>
                <FaQuoteLeft className={classes.ico} />
            </div>
        </div>
    )
}

function OurClients() {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 2
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return (
        <div className={classes.rootCon}>
            {/* <p className={classes["section__subheader"]}>Customer Reviews</p>
            <h2 className={classes["__strong"]}>What Our Customers Say About MILLENSYS.</h2> */}
            <h1 className={classes["heading_sec"]}>What Our Customers Say About MILLENSYS.</h1>
            <Carousel responsive={responsive} showDots infinite autoPlay autoPlaySpeed={2500}  keyBoardControl swipeable  
                draggable   >
                {customers.map((ele,i)=>{return(<Card key={i} title={ele.title} secImg={ele.img} overview={ele.description} name={ele.name}/>)})}
            </Carousel>
        </div>
    )
}

export default OurClients
//infinite
